import { Link } from 'react-router-dom';
import { useFormData } from '../../hooks/useFormData';
import { useFormConfig } from '../../hooks/useFormConfig';
import { hasAdminSessionAccess } from '../../utils/admin-preview';
import { managedQuestions } from '../../utils/managed-options';
import { setSelectedFormIdInSession } from '../../utils/form-id';

export default function ManageValuesButton() {
  const { formConfig, tenant } = useFormConfig();
  const { data } = useFormData();
  if (tenant !== 'gfie' || !hasAdminSessionAccess(data || {}) || !managedQuestions(formConfig).length)
    return null;
  return (
    <Link
      className="govuk-button govuk-button--secondary"
      to={`/${tenant}/manage-values`}
      onClick={() => setSelectedFormIdInSession(tenant, null)}
    >
      Manage form values
    </Link>
  );
}
